/* Sherri Hill 2026 header behaviour: mega menu + dropdown, scroll state, mobile drawer. No dependencies. */
(function () {
  var header = document.querySelector('.js-sh2-header');
  if (!header) return;

  var canHover = function () {
    return window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
  };
  var items = Array.prototype.slice.call(header.querySelectorAll('.js-sh2-menu-item'));
  var openItem = null;
  var timer = null;

  function panelOf(item) { return item.querySelector('.sh2-mega, .sh2-dropdown'); }
  function triggerOf(item) { return item.querySelector('[aria-controls]'); }

  function close(item, returnFocus) {
    if (!item) return;
    var p = panelOf(item), t = triggerOf(item);
    if (p) p.classList.remove('is-open');
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      if (returnFocus) t.focus();
    }
    if (openItem === item) openItem = null;
    header.classList.toggle('is-menu-open', !!openItem);
  }
  function open(item) {
    if (openItem && openItem !== item) close(openItem);
    var p = panelOf(item), t = triggerOf(item);
    if (p) p.classList.add('is-open');
    if (t) t.setAttribute('aria-expanded', 'true');
    openItem = item;
    header.classList.add('is-menu-open');
  }

  items.forEach(function (item) {
    var t = triggerOf(item);
    item.addEventListener('mouseenter', function () {
      if (!canHover()) return;
      clearTimeout(timer);
      open(item);
    });
    item.addEventListener('mouseleave', function () {
      if (!canHover()) return;
      clearTimeout(timer);
      timer = setTimeout(function () { close(item); }, 120);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close(item);
    });
    if (t) t.addEventListener('click', function () {
      /* On hover devices the pointer already opened the menu on mouseenter, so a click must not toggle it
         shut again. There, Escape, moving away or clicking outside closes it. Touch/keyboard-only: toggle. */
      if (canHover()) { open(item); return; }
      if (openItem === item) close(item); else open(item);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) close(openItem, true);
  });
  document.addEventListener('mousedown', function (e) {
    if (openItem && !openItem.contains(e.target)) close(openItem);
  });

  var overlay = header.classList.contains('sh2-header--overlay');
  var onScroll = function () {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
    if (overlay) {
      /* Homepage overlay: solid once the hero film has scrolled up under the bar. */
      var hero = document.querySelector('[data-sh2-hero]');
      var limit = hero ? Math.max(8, hero.getBoundingClientRect().bottom + window.scrollY - header.offsetHeight - 8) : 8;
      header.classList.toggle('is-solid', window.scrollY > limit);
    }
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Slide-out search panel and cart drawer. Both panels already exist in the theme; the old header
     opened them with the theme's Toggle utility (themeCore.utils.Toggle), so we do the same. Toggle binds
     every [data-js-toggle="<name>"] element present at init, including the panels' own close buttons,
     so it must run once, after the DOM is ready. main.build.min.js may load after this file: poll briefly. */
  function initThemeDrawers(tries) {
    if (window.__sh2DrawersReady) return;
    var T = window.themeCore && window.themeCore.utils && window.themeCore.utils.Toggle;
    if (!T) {
      if (tries < 100) setTimeout(function () { initThemeDrawers(tries + 1); }, 50);
      return;
    }
    window.__sh2DrawersReady = true;
    if (header.querySelector('[data-js-toggle="searchToggleDrawer"]') && document.getElementById('headerDrawerSearch')) {
      var input = document.querySelector('#headerDrawerSearch input[name="q"]');
      T({ toggleSelector: 'searchToggleDrawer', toggleTabIndex: true, elementToFocus: input }).init();
    }
    if (header.querySelector('[data-js-toggle="CartDrawer"]') && document.getElementById('CartDrawer')) {
      T({ toggleSelector: 'CartDrawer', toggleTabIndex: true }).init();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initThemeDrawers(0); });
  } else {
    initThemeDrawers(0);
  }

  /* Mobile drawer */
  var drawer = document.getElementById('sh2-mobile-menu');
  var openBtn = header.querySelector('.js-sh2-menu-open');
  if (!drawer || !openBtn) return;
  var closeBtn = drawer.querySelector('.sh2-drawer__close');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('sh2-no-scroll');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sh2-no-scroll');
    openBtn.focus({ preventScroll: true });
  }
  openBtn.addEventListener('click', openDrawer);
  Array.prototype.forEach.call(drawer.querySelectorAll('.js-sh2-menu-close'), function (b) {
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
